import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=84fb8b64&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84fb8b64')) {
      api.createRecord('84fb8b64', component.options)
    } else {
      api.reload('84fb8b64', component.options)
    }
    module.hot.accept("./NotFoundComponent.vue?vue&type=template&id=84fb8b64&", function () {
      api.rerender('84fb8b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotFoundComponent.vue"
export default component.exports